import { _request_KEYCLOAK } from "../../request/_request_KEYCLOAK";

export const getInvoicesByCnpj = async ({
  cnpj,
  targetCnpj,
  targetEstado,
  year,
  month,
  invoicePage = 1,
  invoicePageSize = 5,
  estados,
  cnpjs,
  statusPagamento,
}) => {
  const response = await _request_KEYCLOAK({
    method: "GET",
    url: `${process.env.REACT_APP_TICKET_INT012}/${cnpj}/finance/${targetCnpj}/${targetEstado}`,
    params: {
      year,
      month,
      invoicePage,
      invoicePageSize,
      ...(estados?.length ? { estados: estados.join(",") } : {}),
      ...(cnpjs?.length ? { cnpjs: cnpjs.join(",") } : {}),
      ...(statusPagamento?.length ? { statusPagamento: statusPagamento.join(",") } : {}),
    },
  });

  return response.data;
};